// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Playfair Display', 'Playfair Display Fallback'"},"className":"__className_e89c35"};